import { render, staticRenderFns } from "./FlexCarouselLayout.vue?vue&type=template&id=a87e1c9e&"
import script from "./FlexCarouselLayout.vue?vue&type=script&lang=js&"
export * from "./FlexCarouselLayout.vue?vue&type=script&lang=js&"
import style0 from "./FlexCarouselLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports